export const daData = `
  <div class="paragraph">
    <div class="page-title">Ofte stillede spørgsmål om Trade-In-programmet (FAQ)</div>
  </div>
  <div class="paragraph">
    <div class="title">Hvem kan deltage i Trade-In-programmet?</div>
    <div class="text-box">
      <div class="text">
        Trade-In-tjenesten er tilgængelig for personer på 18 år eller derover, som lovligt bor i et medlemsland i Den Europæiske Union eller i Det Forenede Kongerige.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Hvad skal jeg gøre, før jeg sender min gamle enhed?</div>
    <div class="text-box">
      <div class="text">
        Før du sender din enhed:<br>
        • Slet alle personlige data, og fjern enhver PIN-kode, adgangskode eller skærmlås.<br>
        • Udfør en fuld fabriksnulstilling.<br>
        • På iPhone: Afbryd din iCloud-konto ved at slå "Find min iPhone" fra.<br>
        • På Android: Fjern din Google-konto (Indstillinger > Konti > Google > Fjern konto).<br>
        Dette sikrer, at enheden ikke længere er knyttet til din konto og beskytter dine personlige oplysninger.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Hvordan sender jeg min gamle enhed?</div>
    <div class="text-box">
      <div class="text">
        <strong>Emballage:</strong> Brug en robust, uigennemsigtig kasse (ikke gennemsigtig), og tilføj indvendig beskyttelse (f.eks. bobleplast) for at undgå skader under transport.<br>
        <strong>Forsendelsesetiket:</strong> Hvis du ikke har passende emballagematerialer, kan du anmode om dem ved afleveringsstedet, når du indleverer pakken.<br>
        <strong>Dokumentation:</strong> Udskriv, udfyld og underskriv Ærlighedserklæringen, og læg den i pakken, inden du lukker den.<br>
        <strong>Sikker forsegling:</strong> Sørg for, at pakken er forsvarligt lukket, og placer den gratis forsendelsesetiket et synligt sted.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Hvilke typer enheder accepteres ikke?</div>
    <div class="text-box">
      <div class="text">
        Vi accepterer ikke enheder, der:<br>
        • er SIM-låst til en operatør;<br>
        • ikke kan tændes eller oplades;<br>
        • ikke kan oprette forbindelse via Bluetooth eller Wi-Fi;<br>
        • har interne komponent- eller bundkortfejl;<br>
        • stadig er knyttet til en iCloud- eller Google-konto;<br>
        • er forfalskninger eller kopier;<br>
        • er alvorligt beskadigede.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Skal jeg sende tilbehør (oplader, kabel osv.)?</div>
    <div class="text-box">
      <div class="text">
        Det er ikke obligatorisk, men anbefales. Ved at inkludere tilbehør bidrager du til bæredygtighed og korrekt genbrug.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Skal jeg sende hovedtelefoner?</div>
    <div class="text-box">
      <div class="text">
        Nej. Af hygiejniske årsager vil hovedtelefoner blive kasseret og ikke medtages i vurderingen.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Skal jeg sende købsfakturaen?</div>
    <div class="text-box">
      <div class="text">
        Nej, det er ikke nødvendigt for vurdering eller betaling. Du kan beholde fakturaen til dine egne optegnelser.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Hvordan vurderes min gamle enhed?</div>
    <div class="text-box">
      <div class="text">
        Vi bruger certificeret diagnostisk software og udfører en manuel inspektion i vores vurderingscenter for at fastslå enhedens tilstand. Alle vurderings- og databehandlingsprocedurer udføres i overensstemmelse med Databeskyttelsesforordningen (GDPR – EU 2016/679) for at sikre sikkerheden og fortroligheden af dine oplysninger.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Hvad sker der, hvis den tilstand, jeg har angivet, ikke stemmer med jeres vurdering?</div>
    <div class="text-box">
      <div class="text">
        Hvis der er forskelle mellem den tilstand, du har angivet, og vores vurdering, sender vi dig en e-mail med:<br>
        • <strong>Et opdateret tilbud</strong> baseret på den faktiske inspektion.<br>
        • <strong>Diagnoserapporten</strong> og årsagerne til forskellen.<br><br>
        Du kan vælge at acceptere eller afvise tilbuddet:<br>
        • Hvis du accepterer, gennemføres Trade-In-processen, og du modtager betalingen på din bankkonto inden for 3 arbejdsdage.<br>
        • Hvis du afviser, afhænger returprocessen af din placering:<br>
        &nbsp;&nbsp;• For kunder i Spanien: Returforsendelsen arrangeres gratis og dækkes af Danghuan Europe S.L.<br>
        &nbsp;&nbsp;• For kunder uden for Spanien: Der pålægges et returgebyr på op til 22 EUR / 19 GBP / 165 DKK / 245 SEK (inkl. moms).<br>
        &nbsp;&nbsp;• Gebyret skal betales inden for 5 kalenderdage efter modtagelse af betalingsanmodningen ved brug af det officielle forudbetalte returforsendelsesetiket leveret af Danghuan.<br>
        &nbsp;&nbsp;• Betalingsoplysninger vil blive fremsendt efter anmodning eller inkluderet i e-mailen med betalingslinket.<br>
        &nbsp;&nbsp;• Når betalingen (hvis relevant) er bekræftet, vil Danghuan kontrollere transaktionen inden for 5 arbejdsdage og arrangere returforsendelsen til din oprindelige adresse.<br>
        &nbsp;&nbsp;• Du modtager en e-mail, når forsendelsen er afsendt, inklusive de tilsvarende sporingsoplysninger.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Hvad sker der, hvis jeg ikke svarer på det opdaterede tilbud?</div>
    <div class="text-box">
      <div class="text">
        Hvis der ikke modtages et svar inden for 30 kalenderdage fra meddelelsesdatoen, betragtes det reviderede tilbud automatisk som afvist.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Hvad sker der med mine personlige data?</div>
    <div class="text-box">
      <div class="text">
        Du skal slette alle data, inden du sender din gamle enhed. Hvis vi opdager resterende data, vil vi sætte processen på pause og kontakte dig for at fjerne dem.Vi overholder fuldt ud GDPR (Forordning EU 2016/679).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Hvem betaler for forsendelsesomkostningerne?</div>
    <div class="text-box">
      <div class="text">
        Den første forsendelse er altid gratis.<br><br>
        Hvis du afviser det opdaterede tilbud:<br>
        • For kunder i Spanien: Returforsendelsen arrangeres gratis og dækkes af Danghuan Europe S.L.<br>
        • For kunder uden for Spanien: Der pålægges et returgebyr på op til 22 EUR / 19 GBP / 165 DKK / 245 SEK (inkl. moms).<br>
        • Gebyret skal betales inden for 5 kalenderdage efter modtagelse af betalingsanmodningen ved brug af det officielle forudbetalte returforsendelsesetiket leveret af Danghuan.<br>
        • Betalingsoplysninger vil blive fremsendt efter anmodning eller inkluderet i e-mailen med betalingslinket.<br>
        • Når betalingen (hvis relevant) er bekræftet, vil Danghuan kontrollere transaktionen inden for 5 arbejdsdage og arrangere returforsendelsen til din oprindelige adresse.<br>
        • Du vil blive underrettet via e-mail, når pakken er sendt, sammen med sporingsoplysningerne.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Hvad sker der, hvis min pakke bliver væk under forsendelsen?</div>
    <div class="text-box">
      <div class="text">
        Hvis din enhed går tabt under transport, vil Danghuan Europe S.L. hjælpe dig med den officielle reklamationsproces hos kureren.<br><br>
        En forsendelse betragtes som tabt, hvis den ikke er blevet sporet, bekræftet eller modtaget af Danghuan inden for 15 kalenderdage fra overdragelsen til kureren.<br><br>
        • Du skal bruge det autoriserede forudbetalte forsendelsesetiket fra Danghuan; brug af andre metoder annullerer dækningen mod tab.<br>
        • Reklamationer for UPS skal indsendes inden for 60 dage fra etikettens oprettelsesdato.<br>
        • For CORREOS (Spanien) skal reklamationer indsendes hurtigst muligt, helst inden for 15 dage og senest inden for 1 år fra forsendelsesdatoen.<br>
        • Danghuan hjælper med kurerens undersøgelse, som normalt tager 30–60 dage.<br><br>
        Hvis tabet bekræftes i Danghuans logistiksystem, og det autoriserede etikett blev anvendt, vil kompensationen ikke overstige den endelige vurderede Trade-In-værdi af enheden.<br><br>
        Godkendte betalinger overføres direkte til det IBAN, der blev angivet ved registreringen.<br><br>
        <em>Bemærk: Enhver kompensation afhænger af kurerselskabets politik.</em>
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Hvornår modtager jeg betalingen?</div>
    <div class="text-box">
      <div class="text">
        Når det endelige tilbud er accepteret, vil betalingen blive foretaget via bankoverførsel inden for 3 arbejdsdage.<br>
        Sørg for, at dit IBAN og dit Personlige ID-nummer er korrekte og stemmer overens med kontohaveren.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Er det obligatorisk at oplyse mit Personlige ID-nummer?</div>
    <div class="text-box">
      <div class="text">
        Ja. For at behandle betalingen skal du give et gyldigt Personligt ID-nummer, uden mellemrum eller specialtegn, og det skal stemme overens med kontohaverens navn på IBAN.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Kan jeg annullere min Trade-In-transaktion?</div>
    <div class="text-box">
      <div class="text">
        Ja, hvis din gamle enhed endnu ikke er blevet betalt. Kontakt os venligst hurtigst muligt på <a href="mailto:insta360@danghuan.eu">insta360@danghuan.eu</a>. Hvis du allerede har sendt din enhed, skal du kontakte os inden for 48 timer; ellers fortsætter genbrugsprocessen som normalt.
      </div>
    </div>
  </div>
`;